import { OrganizationSwitcher } from '@clerk/clerk-react'
import { workspaceSwitcherAppearance } from '../theme/clerkAppearance'

type Variant = 'sidebar' | 'standalone'

const variantClass: Record<Variant, string> = {
  sidebar: 'workspace-org-switcher workspace-org-switcher--sidebar',
  standalone: 'workspace-org-switcher workspace-org-switcher--standalone',
}

/**
 * Clerk OrganizationSwitcher styled for SelfHeal dark surfaces.
 * Sidebar variant avoids clipped org names in the 240px nav panel.
 */
export default function WorkspaceOrganizationSwitcher({
  variant = 'sidebar',
}: {
  variant?: Variant
}) {
  return (
    <div className={variantClass[variant]}>
      <OrganizationSwitcher
        hidePersonal
        afterCreateOrganizationUrl="/investigations"
        // A detail route belongs to the old workspace; land on the new org's list.
        afterSelectOrganizationUrl="/investigations"
        appearance={workspaceSwitcherAppearance}
      />
    </div>
  )
}
